/**
 * Real API implementation for Facility Cleaning Standards.
 */

import { apiClient } from '../apiClient';
import { serviceLogger } from '../../utils/serviceLogger';
import { normalizeServiceError } from '../../utils/serviceError';
import {
  validateFacilityStandards,
  convertShiftsToAPIFormat,
} from '../../utils/cleaningStandardsUtils';

const V3_CLEANING_STANDARDS_FACILITY = '/api/v3/cleaning-standards/facility';

function getFacilityStandardsPath(facilityId) {
  return `${V3_CLEANING_STANDARDS_FACILITY}/${facilityId}`;
}

/**
 * Build request body for facility standards (backend requires non-null; use '' for unset).
 */
function buildFacilityStandardsBody(standards) {
  return {
    waterChanges: standards.waterChanges != null ? standards.waterChanges : '',
    soilLoadLevel: standards.soilLoadLevel != null ? standards.soilLoadLevel : '',
    workShifts:
      standards.workShifts != null && Array.isArray(standards.workShifts)
        ? convertShiftsToAPIFormat(standards.workShifts)
        : [],
  };
}

export const getFacilityStandards = async (facilityId) => {
  if (!facilityId) throw new Error('Facility ID is required');
  try {
    const response = await apiClient.get(getFacilityStandardsPath(facilityId));
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return { success: true, data: null };
    serviceLogger.error('[realGetFacilityStandards] Error:', error);
    throw normalizeServiceError(error);
  }
};

export const upsertFacilityStandards = async (facilityId, standards) => {
  if (!facilityId) throw new Error('Facility ID is required');
  validateFacilityStandards(standards);
  const requestData = buildFacilityStandardsBody(standards);
  try {
    const response = await apiClient.put(
      getFacilityStandardsPath(facilityId),
      requestData,
    );
    return response.data;
  } catch (error) {
    serviceLogger.error('[realUpsertFacilityStandards] Error:', error);
    throw normalizeServiceError(error);
  }
};
